import { type WidgetSetting, type WidgetSettingsDefinition } from "@repo/api";

import { BooleanSettingsControl } from "./BooleanSettingsControl";
import { CoworkerSettingsControl } from "./CoworkerSettingsControl";
import { DateRangeSettingsControl } from "./DateRangeSettingsControl";
import { DepartmentSettingsControl } from "./DepartmentSettingsControl";
import { QuickDateSelectorSettingsControl } from "./QuickDateSelectorSettingsControl/QuickDateSelectorSettingsControl";
import { QuotationRangeSettingsControl } from "./QuotationRangeSettingsControl";
import { SelectionSettingsControl } from "./SelectionSettingsControl";
import { ServicesSettingsControl } from "./ServicesSettingsControl";
import { StoreSettingsControl } from "./StoreSettingsControl";
import { TagSettingsControl } from "./TagSettingsControl";
import { TaskSelectSettingsControl } from "./TaskSelectSettingsControl";
import { ValueRangeSettingsControl } from "./ValueRangeSettingsControl";

export const SettingsControl = ({
  settingDefinition,
  setting,
  setSetting,
}: {
  settingDefinition: WidgetSettingsDefinition;
  setting: Record<string, any>;
  setSetting: (newSetting: WidgetSetting) => void;
}) => {
  if (settingDefinition.type === "boolean") {
    return (
      <BooleanSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  if (settingDefinition.type === "store") {
    return (
      <StoreSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  if (settingDefinition.type === "interested_services") {
    return (
      <ServicesSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  if (settingDefinition.type === "coworker") {
    return (
      <CoworkerSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  if (settingDefinition.type === "selection") {
    return (
      <SelectionSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  if (settingDefinition.type === "value_range") {
    return (
      <ValueRangeSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  if (settingDefinition.type === "task_select") {
    return (
      <TaskSelectSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  if (settingDefinition.type === "date_range") {
    return (
      <DateRangeSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  if (settingDefinition.type === "quotation_range") {
    return (
      <QuotationRangeSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  if (settingDefinition.type === "quick_date_selector") {
    return (
      <QuickDateSelectorSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  if (settingDefinition.type === "department_select") {
    return (
      <DepartmentSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }
  if (settingDefinition.type === "tag_select") {
    return (
      <TagSettingsControl
        settingDefinition={settingDefinition}
        setting={setting}
        setSetting={setSetting}
      />
    );
  }

  return null;
};
